// extracted by mini-css-extract-plugin
module.exports = {"card":"base-card_card__i9HpN","cardBoxShadow":"base-card_cardBoxShadow__H_thB","cardBorder":"base-card_cardBorder__iyKne"};